module.exports = __webpack_public_path__ + "static/media/Image43.9d63cd64.jpg";